import { memo } from 'react'

import { ColumnType } from '~shared/rundown/column'

import { RichtextColumnCell } from './cell-types/richtext/RichtextColumnCell'
import { SelectColumnCell } from './cell-types/select/SelectColumnCell'
import { useCellColumn } from './cell.hooks'

/**
 * Renders a cell inside a cue.
 */
export const Cell = memo(function Cell() {
  const column = useCellColumn()

  // Determine which component to render based on column type
  if (column.type === ColumnType.SELECT) {
    return <SelectColumnCell />
  } else {
    return <RichtextColumnCell />
  }
})
